import React, { useState, Fragment } from 'react';

import { Link } from 'react-router-dom';
import { AlignLeft } from 'react-feather';

const Header = () => {
  const [sidebar, setSidebar] = useState(false);

  function openCloseSidebar() {
    if (sidebar) {
      setSidebar(!sidebar);
      document.querySelector(".page-main-header").classList.remove('open');
      document.querySelector(".page-sidebar").classList.remove('open');
    } else {
      setSidebar(!sidebar);
      document.querySelector(".page-main-header").classList.add('open');
      document.querySelector(".page-sidebar").classList.add('open');
    }
  }

  return (
    <Fragment>
      <div className="page-main-header"  >
        <div className="main-header-right row" >

          <div className="mobile-sidebar d-block col-auto">
            <div className="flex-grow-1 text-end switch-sm">
              <label className="switch">
                <a href="#javascript" onClick={() => openCloseSidebar()}>
                  <AlignLeft />
                </a>
              </label>
            </div>
          </div>
          <div className="main-header-left col-auto">
            <div className="logo-wrapper d-lg-12">
              {/* <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
                <img
                  className="img-fluid img-header"
                  src={`${process.env.PUBLIC_URL}/logo.jpg`}
                  alt=""
                />
              </Link> */}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
};
export default Header;